var scope_0 = require('/Users/dumarkus/Desktop/Medzcool/frontend/nucleotype/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/401b2b657ca5cabc65dd44842fd9f2e0.js').default;
var scope_1 = require('/Users/dumarkus/Desktop/Medzcool/frontend/nucleotype/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4de18b6fe6f0a0dbe088c770db683107.js').default;
var scope_2 = require('/Users/dumarkus/Desktop/Medzcool/frontend/nucleotype/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/71b41c87bf6596da1c84666825fe505d.js').default;
var scope_3 = require('/Users/dumarkus/Desktop/Medzcool/frontend/nucleotype/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    